import React, { useEffect, useState } from 'react';
import { PlayerButton } from './PlayerButton';
import type { FollowerReadyState, SyncedSessionManager } from '../../synced-session/types';

interface Props {
  manager: SyncedSessionManager;
}

const READY_CLASS: Record<FollowerReadyState, string> = {
  ready: 'kollab-player-sync-btn kollab-player-sync-btn--ready',
  waiting: 'kollab-player-sync-btn kollab-player-sync-btn--waiting',
  disconnected: 'kollab-player-sync-btn kollab-player-sync-btn--disconnected',
};

const READY_TOOLTIP: Record<FollowerReadyState, string> = {
  ready: 'All followers ready',
  waiting: 'Waiting for followers to buffer',
  disconnected: 'Session disconnected',
};

/**
 * Non-interactive indicator for the leader: shows composite follower-ready
 * state. Orange while any follower is buffering (`KWAIT`), green once all
 * followers have sent `KREADY` (`KALLREADY` from the server).
 */
export function FollowerReadyButton({ manager }: Props) {
  const [state, setState] = useState<FollowerReadyState>(manager.getReadyState());

  useEffect(() => {
    const off = manager.on('readyStateChange', (e) => setState(e.state));
    return () => { off(); };
  }, [manager]);

  return (
    <PlayerButton
      className={READY_CLASS[state]}
      tooltip={READY_TOOLTIP[state]}
      aria-live="polite"
      data-ready-state={state}
    />
  );
}

export default FollowerReadyButton;
